<template>
  <div>
    <div class="">
      <ul class="news-wrap">
        <li v-for="item in list" :key="item.title">
          <div class="news-item pointer" @click="gotonew(item)">
            <span class="title" :class="[item.topStatus == 2 ? 'top' : '']">{{ item.title }}</span>
            <span class="date">{{ item.publishTm ? item.publishTm.slice(0, 10) : '' }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import grid from '@/mixins/grid'

export default {
  name: 'NewsContent',
  // mixins: [grid],
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // list: [],
    }
  },

  computed: {
    // currentList() {
    //   switch (this.currentTab) {
    //     case 0:
    //       return this.noticeList
    //     case 1:
    //       return this.activityList
    //     default:
    //       return []
    //   }
    // },
  },
  methods: {
    gotonew(item) {
      if (item.urlStatus == 1) {
        this.$router.push(`/news-detail/${item.id}`)
      } else {
        window.open(item.contUrl, '_blank')
      }
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .title-wrap {
    .more {
      font-size: 20px;
      color: rgba(153, 153, 153, 0.99);
    }
  }
  .content-wrap {
    background: #ffffff;
    box-shadow: 0px 2px 9px 0px rgba(235, 236, 244, 1);
    border-radius: 0px 10px 10px 10px;
    .tab-wrap {
      display: flex;
      border-bottom: 1px solid rgba(242, 245, 255, 1);
      .tab-item {
        width: 180px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all var(--transition-duration);
        &.active,
        &:hover {
          background: rgba(27, 91, 250, 0.06);
          span {
            font-weight: 600;
            color: #1b5bfa;
            border-left-color: #1b5bfa;
          }
        }
        span {
          width: 100%;
          font-size: 18px;
          color: #707070;
          letter-spacing: 0;
          font-weight: 600;
          text-align: center;
          border-left: 2.5px solid;
          transition: all var(--transition-duration);
          border-left-color: transparent;
        }
      }
    }
    .news-wrap {
      padding: 18px 30px;
      li {
        &:not(:last-child) {
          border-bottom: 1px dashed #e7e7e7;
        }
        .news-item {
          display: flex;
          align-items: center;
          padding: 10px 0;
          .title {
            flex: 0 1 70%;
            font-size: 16px;
            color: #333;
            letter-spacing: 0;
            font-weight: 600;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /* 这里是超出几行省略 */
            &.top {
              &::before {
                content: '';
                display: inline-block;
                margin-right: 4px;
                width: 20px;
                height: 20px;
                background: url(../../../../assets/images/置顶.png);
                background-size: 100% 100%;
                vertical-align: -4px;
              }
            }
          }
          .date {
            flex: 1;
            font-size: 16px;
            color: #707070;
            letter-spacing: 0;
            text-align: right;
            font-weight: 400;
          }
        }
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
